import React from "react";
import { Paper, styled } from "@mui/material";

export const TransparentPaper = styled(Paper)({
  background: "transparent",
  boxShadow: "none",
});
